import { ga4Mapper } from '../ga4-mapper'

const EVENT = 'manageBooking'
const ELEMENT = 'button'

function getBookingNumber (data) {
  return data && data.bookingNumber ? data.bookingNumber : 'unknown'
}

function mapGA4 ({ description, result, interaction = true }) {
  return ga4Mapper({
    event: EVENT,
    description,
    element: ELEMENT,
    result,
    interaction
  })
}

export const openFullCancellationConditionsMapper = (data) => {
  if (!data) return null

  const booking = getBookingNumber(data)

  const result = !data.isSuccess
    ? `Open full cancellation failed for booking ${booking}`
    : data.isWithCost
      ? `Open full cancellation with cost for booking ${booking}`
      : `Open full cancellation without cost for booking ${booking}`

  return mapGA4({
    description: 'Opened full cancellation conditions',
    result
  })
}

export const confirmFullCancellationMapper = (data) => {
  if (!data) return null

  const booking = getBookingNumber(data)
  const costText = data.amount ? `${data.amount}€` : 'unknown cost'

  const result = data.isSuccess
    ? data.isWithCost
      ? `Full cancellation confirmed with cost (${costText}) for booking ${booking}`
      : `Full cancellation confirmed without cost for booking ${booking}`
    : `Full cancellation failed for booking ${booking}`

  return mapGA4({
    description: 'Full cancellation action',
    result
  })
}

export const openPartialCancellationConditionsMapper = (data) => {
  if (!data) return null

  const booking = getBookingNumber(data)

  const result = !data.isSuccess
    ? `Open partial cancellation failed for booking ${booking}`
    : data.isWithCost
      ? `Open partial cancellation with cost for booking ${booking}`
      : `Open partial cancellation without cost for booking ${booking}`

  return mapGA4({
    description: 'Opened partial cancellation conditions',
    result
  })
}

export const confirmPartialCancellationMapper = (data) => {
  if (!data) return null

  const participantsText = data.participantsNum
    ? `${data.participantsNum} participant(s)`
    : '0 participants'

  const statusText = data.isSuccess
    ? data.isWithCost
      ? 'Confirmed partial cancellation with cost'
      : 'Confirmed partial cancellation without cost'
    : 'Partial cancellation failed'

  return mapGA4({
    description: 'Partial cancellation action',
    result: `${statusText} (${participantsText}) for booking ${getBookingNumber(data)}`
  })
}
